module.exports = __webpack_public_path__ + "static/media/mc.de8308f1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mc.svg
// module id = 2149
// module chunks = 0